type ThreeimagesWithTextProps = {
  textContent: JSX.Element;
  image1: JSX.Element;
  image2: JSX.Element;
  image3: JSX.Element;
};

type Props = React.ComponentPropsWithoutRef<'div'> & ThreeimagesWithTextProps;
const ThreeImagesWithText = ({ className = '', children, textContent, image1, image2, image3, ...props }: Props) => {
  return (
    <div className="m-section container">
      <div className="row">
        <div className="hidden lg:col-span-1 lg:block" />

        <div className="col-span-11 sm:col-span-8 md:col-span-4 lg:col-span-3">
          <div className="mb-32 space-y-32 md:mb-0">{textContent}</div>
        </div>

        <div className="hidden xs:col-span-1 xs:block sm:col-span-4 md:hidden" />

        <div className="col-span-2 xs:col-span-1 md:hidden lg:col-span-1 lg:block" />

        <div className="row col-span-10 space-y-4 xs:col-span-11 md:col-span-8 md:space-y-0 lg:col-span-7">
          <div className="col-span-12 xs:col-span-4">{image1}</div>

          <div className="col-span-12 xs:col-span-4">{image2}</div>

          <div className="col-span-12 xs:col-span-4">{image3}</div>
        </div>
      </div>
    </div>
  );
};

export default ThreeImagesWithText;
